import React from 'react';
import PropTypes from 'prop-types';
import GetVideoId from 'get-video-id';
import { Carousel } from 'react-responsive-carousel';
import { ViewerPrimaryColorUserStyle } from '../../UserCustomization';

import withModal from '../WithModal';
import svgInline from '../../SvgInline/SvgInline';
import closeIcon from '../../../shared/assets/icon-close.svg';
import './VideoModal.css';
import '../../../../node_modules/react-responsive-carousel/lib/styles/carousel.min.css';

export function standardizeVideoURL(url) {
  const videoId = GetVideoId(url);

  if (!videoId) {
    return '';
  } else if (videoId.service !== 'youtube') {
    window.open(url);
    return false;
  }

  return `https://www.youtube.com/embed/${videoId.id}`;
}

export function VideoModalComponent({ onModalClick, urlList }) {
  const standardizedUrls = [];
  urlList.forEach(url => {
    const stdUrl = standardizeVideoURL(url);
    if (stdUrl) {
      standardizedUrls.push(stdUrl);
    }
  });

  return (
    <div className="modal-wrapper video-modal">
      <ViewerPrimaryColorUserStyle domStyle="backgroundColor">
        <div className="modal-header">
          <h2 className="modal-title">Video</h2>
          <a tabIndex="0" onClick={onModalClick}>
            <div className="modal-close">
              {svgInline(closeIcon)}
            </div>
          </a>
        </div>
      </ViewerPrimaryColorUserStyle>
      <div className="modal-body">
        <Carousel showThumbs={false} showIndicators={false} showArrows className="video-modal-form">
          {urlList.map(url => {
            if (standardizedUrls.indexOf(standardizeVideoURL(url)) > -1) {
              return <iframe key={url} src={standardizeVideoURL(url)} frameBorder="0" allowFullScreen />;
            }
            return (
              <div key={url} className="offsite">
                <a className="button" href={url} target="_blank" rel="noopener noreferrer">
                  Click here to view this video
                </a>
              </div>
            );
          })}
        </Carousel>
      </div>
    </div>
  );
}

VideoModalComponent.propTypes = {
  onModalClick: PropTypes.func.isRequired,
  urlList: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default withModal(VideoModalComponent, 'video');



// WEBPACK FOOTER //
// ./src/components/Modal/VideoModal/VideoModal.js